
import Vue from "vue";
import { IInvoiceData } from "../types";
import { DATE_FORMAT } from "../constants/DateFormats";
import fieldEntryMixin from "@/components/mixins/fieldEntryMixin.vue";

export default Vue.extend({
  name: "invoice-selector-list",
  mixins: [fieldEntryMixin],
  props: {
    invoices: { type: Array as () => IInvoiceData[] }
  },
  methods: {
    invoiceClicked(documentNumber: string) {
      this.$emit("invoiceSelected", documentNumber);
    },
    convertToCurrency(number: number): string {
      //@ts-ignore
      return this.formatPrice(number, false);
    },
    formatInvoiceDate(date: string): string {
      //@ts-ignore
      return this.$moment(date).format(DATE_FORMAT.LOCAL_DATE_FORMAT);
    }
  }
});
